import React from "react";
import RowContainer from "../Common/RowContainer";
import { removeInlineColors } from "../../utils/htmlColorUtils";
import '../../stylesheets/common.css';

interface BlockTextComponentProps {
  id: number;
  description: string;
  lightTheme?: string | null;
  textColor?: string;           // explicit text color override
  bgColor?: string;             // explicit bg color override
  isBretzel?: boolean;
  flashCardContentComponentId?: number;
  onClick?: () => void;
}

/**
 * Flutter logic:
 *   lightTheme == "Light" || null  → bg #110929, text white
 *   britzelId == null (dark theme) → bg transparent, text #16162F
 *   britzelId != null (bretzel)    → bg white, text #16162F
 */
const BlockTextComponent: React.FC<BlockTextComponentProps> = ({
  description,
  lightTheme,
  textColor: textColorProp,
  bgColor: bgColorProp,
  isBretzel = false,
  onClick,
}) => {
  let bgColor: string;
  let textColor: string;

  if (textColorProp !== undefined || bgColorProp !== undefined) {
    // Explicit overrides from parent (e.g. GrammarGroupComponent per-child theming)
    bgColor = bgColorProp ?? "transparent";
    textColor = textColorProp ?? (lightTheme === "Dark" ? "#FFFFFF" : "#16162F");
  } else if (lightTheme == null || lightTheme === "Light") {
    bgColor = "#110929";
    textColor = "#FFFFFF";
  } else if (isBretzel) {
    bgColor = "#FFFFFF";
    textColor = "#16162F";
  } else {
    bgColor = "transparent";
    textColor = "#16162F";
  }

  const padding = bgColorProp !== undefined
    ? (bgColor === "transparent" ? "0px" : "16px 12px")
    : (lightTheme == null || lightTheme === "Light" || isBretzel ? "16px 12px" : "0px");

  const cleanHtml = removeInlineColors((description as any)?.cleanUpString?.() ?? description ?? "");

  return (
    <RowContainer
      className="block-text-component"
      alignItem="center"
      justifyContent="center"
      borderRadius="24px"
      padding={padding}
      cursor="pointer"
      color={textColor}
      bgColor={bgColor}
      onClick={onClick}
    >
      <div
        style={{ color: textColor, background: "transparent" }}
        dangerouslySetInnerHTML={{ __html: cleanHtml }}
      />
    </RowContainer>
  );
};

export default BlockTextComponent;
